import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const InvoicePage = () => (
  <Layout>
  <div className="masthead-followup row m-0 bg-white border border-white text-center">
	  <div className="col-12 col-md-12 p-12 p-3 p-md-5 bg-white border border-white text-dark text-center">
    <Seo title="SOFTWARE INVOICE,PROGRAM INVOICE,APLIKASI INVOICE ONLINE" />
    <h2><strong>OFFICE INVOICE</strong></h2>
    <p>
Software program invoice faktur penjualan hingga pencatatan tender project, hingga kebutuhan akan inventori management stok plus accounting akuntansi system.
	</p></div><hr/>
<div className="col-12 col-md-8 shadow">
<img src="https://res.cloudinary.com/hockeycorp/image/upload/v1579971008/Software%20APlikasi%20Program%20kasir/invoicepenjualan_-_Copy_bkhzpr.png" alt="software invoice program faktur penjualan" class="img-fluid"/>
</div>
<div className="col-12 col-md-4 p-3 p-md-5 bg-white border border-white text-left text-dark shadow rounded">	 
	 <h3 className="display-4"><Link to="/next" title="next invoice online">THE NEXT INVOICE</Link></h3>
	 <p className="lead">Invoice online pembukuan dan tender project</p>
	  <Link to="/next" class="button btn-block" title="invoice online">More info</Link>
	  	  </div>
	  <div className="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-center"></div>
		  <div className="col-12 col-md-8 shadow">
<img src="https://res.cloudinary.com/hockeycorp/image/upload/v1579971002/Software%20APlikasi%20Program%20kasir/invoice_m2vnj7.png" alt="online invoice inventori" class="img-fluid"/>
</div>
<div className="col-12 col-md-4 p-12 p-3 p-md-5 bg-light border border-white text-left text-dark shadow rounded">	 
	  <h3 className="display-4"><Link to="/simple" title="invoice inventori online">SIMPLE MANAGEMENT</Link></h3>
	  <p className="lead">Simple management invoice dan inventori online dual based</p>
	  	  <Link to="/simple" title="invoice inventori online" className="button btn-block">More info</Link>
	  </div>
	   <div className="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-center"></div>
 <div className="col-12 col-md-8 shadow">
<img src="https://res.cloudinary.com/hockeycorp/image/upload/v1579970772/Software%20APlikasi%20Program%20kasir/6_acounting_vae9by.png" alt="software accounting" class="img-fluid"/>
</div>
<div className="col-12 col-md-4 p-3 p-md-5 bg-white border border-white text-left text-dark shadow rounded">	 
	  <h3 className="display-4"><Link to="/accounting" title="accounting akuntansi online">DIGITAL ACCOUNTING</Link></h3>	  
	 <p className="lead">Akuntansi accounting online lengkap dan simple</p>
<Link to="/accounting" className="button btn-block" title="accounting akuntansi online">More info</Link>
	  </div>
	  <div className="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-center"></div>
 <div className="col-12 col-md-8 shadow">
<img src="https://1.bp.blogspot.com/-loDASoj8yCI/X-SW3BXuEZI/AAAAAAAAMTI/q1nQKSOkP6gRpjjM_15GLqZ0DRZa-EX8QCLcBGAsYHQ/s2000/aplikasi%2Bakuntansi%2Bonline%2Bmurah.jpg" alt="aplikasi akuntansi" class="img-fluid"/>
</div>
<div className="col-12 col-md-4 p-3 p-md-5 bg-white border border-white text-left text-dark shadow rounded">	 
	  <h3 className="display-4"><Link to="/accounting" title="accounting akuntansi online">AKUNTANSI</Link></h3>	  
	 <p className="lead">APlikasi akuntansi mudah digunakan</p>
<Link to="/akuntansi" className="button btn-block" title="accounting akuntansi online">More info</Link>
	  </div>
 
	</div>
  </Layout>
)

export default InvoicePage